import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { FullActivationStatus } from "../model/FullActivationStatus";

const rootPath = "/register-api/api/v1/register";

export default class DemoColdirettiPopUpApi {
    
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getSubscriptionStatus(): Promise<boolean> {
        const res = await this.http.get(`${rootPath}/full-activation-status`);
        return res.data;
    }

    public async updateSubscriptionStatus(
        fullActivationStatus: FullActivationStatus
    ): Promise<void> {
        const res = await this.http.post(
            `${rootPath}/request-full-activation`,
            fullActivationStatus
        );
        return res.data;
    }
}
